import React, { useEffect, useState, useContext } from 'react'
import MainViewWrapper from './MainViewWrapper'
import { Input, Button} from 'antd';
import MapEditor from './MapEditor';
import { Row, Col, Tag } from 'antd';
import { auditInfoContext } from '../hooks/startAuditHook';
import { useCookies } from 'react-cookie'
import { createAudit } from '../api/api'
import { openNotification } from './utils';

const { TextArea } = Input;

const adjustGraphicsFormat = (items) => {
    let array = []
    for (var i = 0; i < items.length; i++) {
        let graphic = items[i]
        const type = graphic.geometry.type
        const rings = graphic.geometry.rings
        const geometry = {
            type, rings
        }
        const symbolType = graphic.symbol.type
        const symbolColor = graphic.symbol.color
        const symbolOutline = graphic.symbol.outline

        const fillSymbol = {
            type: symbolType,
            color: symbolColor,
            outline: symbolOutline
        }
        array.push({
            geometry, symbol: fillSymbol
        })
    }
    return array
}

function dataURItoBlob(dataURI) {
    // convert base64 to raw binary data held in a string
    // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
    var byteString = atob(dataURI.split(',')[1]);
  
    // separate out the mime component
    var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]
  
    // write the bytes of the string to an ArrayBuffer
    var ab = new ArrayBuffer(byteString.length);
  
    // create a view into the buffer
    var ia = new Uint8Array(ab);
  
    // set the bytes of the buffer to the correct values
    for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }
  
    // write the ArrayBuffer to a blob, and you're done
    var blob = new Blob([ab], {type: mimeString});
    return blob;
  
  }

const StartAudit = (props) => {

    // const urlSearchParams = new URLSearchParams(window.location.search);
    // const params = Object.fromEntries(urlSearchParams.entries());

    const [ auditName, setAuditName ] = useState("")
    const [ description, setDescrption ] = useState("")
    const [ email, setEmail ] = useState("")
    const [ emails, setEmails ] = useState([]) 
    const { auditInfo, dispatchAuditInfo } = useContext(auditInfoContext)
    const [cookies, setCookie] = useCookies(['name']);
    const version = 1

    const addEmailToEmails = () => {
        if(email.trim().length > 0) {
            setEmails([...emails, email])
            setEmail("")
        }
    }

    const handleSubmitAudit = async () => {
        const data = {
            auditName, 
            description, 
            version,
            image: auditInfo.imgData.dataUrl,
            mapInfo: {
                urls: auditInfo.urls,
                graphics: adjustGraphicsFormat(auditInfo.graphics),
            },
            JWTToken: cookies['JWTToken'],
            approvers: emails,
            creator: cookies['email']
        }
        const resp = await createAudit(data)
        console.log(resp.data)
        openNotification(resp.data)
        
    }

    return <>
            <Row style={{marginBottom: 10}}>
                <Col span={24}>
                    Audit Project Name:
                </Col>
                <Col span={24}>
                    <Input
                        style={{marginTop:10}} 
                        value={auditName} 
                        onChange={(e) => {
                            setAuditName(e.target.value)
                        }}
                    />
                </Col>
            </Row>
            <Row style={{marginBottom: 10}}>
                <Col span={24}>
                    Version
                </Col>
                <Col span={24}>
                    <Input
                        style={{marginTop:10}} 
                        value={version}
                    />
                </Col>
            </Row>
            <Row style={{marginBottom: 10}}>
                <Col span={24}>
                    Audit Project Description
                </Col>
                <Col span={24}>
                    <TextArea
                        rows={2} 
                        style={{marginTop:10}}
                        value={description} 
                        onChange={(e) => {
                            setDescrption(e.target.value)
                        }}
                    />
                </Col>
            </Row>
            <Row style={{marginBottom: 10}} gutter={16}>
                <Col span={24}>
                    Audit Project Email Recipients 
                </Col>
                <Col span={24}>
                    <Input 
                        style={{marginTop:10, marginBottom: 10, marginRight: 10, width: '50%'}}
                        value={email} 
                        onChange={(e) => {
                            console.log(e.target.value)
                            setEmail(e.target.value)
                        }}
                    />
                    <Button onClick={addEmailToEmails}> Add Email </Button>
                </Col>
                <Col span={24}>
                    {
                        emails.map((txt, index) => {
                            return  <Tag closable key={index} onClose={
                                    ()=>{
                                        setEmails(emails.filter((val) => {return val !== txt}))
                                    }}>
                                        {txt}
                                    </Tag>
                        })
                    }
                </Col>
            </Row>
            <MapEditor />
            <Button type="primary" onClick={handleSubmitAudit}>Create Template</Button>
           </>
}

const Wrapper = () => {
    return < MainViewWrapper>
                <StartAudit />
           </MainViewWrapper>
}

export default Wrapper